<!-- <app-header [user]="user"></app-header> -->
<!-- <nav class="nav">
  <a class="nav-link" [ngClass]="{'active': isHome, 'link-dark': !isHome}" [attr.aria-current]="isHome ? 'page' : null" (click)="navigate('home')" onclick="return false" href="/">
    <i class="bi bi-house me-1"></i>
    Home
  </a>
  @if (utente.isUtenteAdmin || utente.isUtenteResponsabileGerarchico) {
    <a class="nav-link" [ngClass]="{'active': isResponsabileGerarchico, 'link-dark': !isResponsabileGerarchico}" [attr.aria-current]="isResponsabileGerarchico ? 'page' : null" (click)="navigate('responsabile-gerarchico/homepage')" onclick="return false" href="/">
      <i class="bi bi-person-badge me-1"></i>
      Responsabile Gerarchico
    </a>
  }

</nav> -->
<!-- <nav class="navbar fixed-top bg-slate-100 mt-100">
  <div class="container-fluid">
    <button class="navbar-toggler bg-primary" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav" #navbarNav>
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{'active': isHome, 'link-dark': !isHome}" [attr.aria-current]="isHome ? 'page' : null" (click)="navigate('home')" onclick="return false" href="/">
            <i class="bi bi-house me-1"></i>
            Home
          </a>
        </li>
        @if (utente.isUtenteAdmin || utente.isUtenteResponsabileGerarchico) {
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': isResponsabileGerarchico, 'link-dark': !isResponsabileGerarchico}" [attr.aria-current]="isResponsabileGerarchico ? 'page' : null" (click)="navigate('responsabile-gerarchico/homepage')" onclick="return false" href="/">
              <i class="bi bi-person-badge me-1"></i>
              Responsabile Gerarchico
            </a>
          </li>
        }
        @if (utente.isUtenteAdmin || utente.isUtenteResponsabilePrimoLivello) {
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': isResponsabilePrimoLivello, 'link-dark': !isResponsabilePrimoLivello}" [attr.aria-current]="isResponsabilePrimoLivello ? 'page' : null" (click)="navigate('responsabile-primo-livello/homepage')" onclick="return false" href="/">
              <i class="bi bi-person-check me-1"></i>
              Responsabile Primo Livello
            </a>
          </li>
        }
        @if (utente.isUtenteAdmin || utente.isUtenteResponsabileCommessa) {
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{'active': isResponsabileCommessa, 'link-dark': !isResponsabileCommessa}" [attr.aria-current]="isResponsabileCommessa ? 'page' : null" (click)="navigate('responsabile-commessa/homepage')" onclick="return false" href="/">
            <i class="bi bi-briefcase me-1"></i>
            Responsabile Commessa
          </a>
        </li>
      }
      @if (utente.isUtenteAdmin || utente.isUtentePianificazioneControllo) {
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{'active': isPianificazioneControllo, 'link-dark': !isPianificazioneControllo}" [attr.aria-current]="isPianificazioneControllo ? 'page' : null" (click)="navigate('pianificazione-controllo/homepage')" onclick="return false" href="/">
            <i class="bi bi-calendar-check me-1"></i>
            Pianicazione e Controllo
          </a>
        </li>
      }
      @if (utente.isUtenteAdmin || utente.isUtenteControllerBU) {
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{'active': isControllerBU, 'link-dark': !isControllerBU}" [attr.aria-current]="isControllerBU ? 'page' : null" (click)="navigate('controller-bu/homepage')" onclick="return false" href="/">
            <i class="bi bi-graph-up me-1"></i>
            Controller BU
          </a>
        </li>
      }
      @if (utente.isUtenteAdmin || utente.isUtenteControllerCentrale) {
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{'active': isControllerCentrale, 'link-dark': !isControllerCentrale}" [attr.aria-current]="isControllerCentrale ? 'page' : null" (click)="navigate('controller-centrale/homepage')" onclick="return false" href="/">
            <i class="bi bi-graph-up-arrow me-1"></i>
            Controller Centrale
          </a>
        </li>
      }
      @if (utente.isUtenteAdmin || utente.isUtenteCFO) {
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{'active': isCFO, 'link-dark': !isCFO}" [attr.aria-current]="isCFO ? 'page' : null" (click)="navigate('cfo/homepage')" onclick="return false" href="/">
            <i class="bi bi-graph-up-arrow me-1"></i>
            CFO
          </a>
        </li>
      }
      @if (utente.isUtenteAdmin || utente.isUtenteCOO) {
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{'active': isCOO, 'link-dark': !isCOO}" [attr.aria-current]="isCOO ? 'page' : null" (click)="navigate('coo/homepage')" onclick="return false" href="/">
            <i class="bi bi-people me-1"></i>
            COO
          </a>
        </li>
      }
      </ul>
    </div>
  </div>
</nav> -->
<main class="padding-container" style="min-height: 100%">
  <mat-sidenav-container class="example-container">
    <mat-sidenav #sidenavMenu class="example-sidenav bg-slate-100" mode="over" style="width: 280px;">
      <div class="d-flex flex-column flex-shrink-0 p-3">
        <ul class="nav nav-pills flex-column mb-auto">
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': isHome, 'link-dark': !isHome}"
              [attr.aria-current]="isHome ? 'page' : null" (click)="navigate('home')" onclick="return false" href="/">
              <i class="bi bi-house me-1"></i>
              Home
            </a>
          </li>
          @if (utente.isUtenteAdmin || utente.isUtenteResponsabileGerarchico) {
          <li>
            <a class="nav-link" [ngClass]="{'active': isResponsabileGerarchico, 'link-dark': !isResponsabileGerarchico}"
              [attr.aria-current]="isResponsabileGerarchico ? 'page' : null"
              (click)="navigate('responsabile-gerarchico/homepage')" onclick="return false" href="/">
              <i class="bi bi-person-workspace me-1"></i>
              Responsabile Gerarchico
            </a>
          </li>
          }
          @if (utente.isUtenteAdmin || utente.isUtenteResponsabilePrimoLivello) {
          <li>
            <a class="nav-link"
              [ngClass]="{'active': isResponsabilePrimoLivello, 'link-dark': !isResponsabilePrimoLivello}"
              [attr.aria-current]="isResponsabilePrimoLivello ? 'page' : null"
              (click)="navigate('responsabile-primo-livello/homepage')" onclick="return false" href="/">
              <i class="bi bi-person-check me-1"></i>
              Responsabile Primo Livello
            </a>
          </li>
          }
          @if (utente.isUtenteAdmin || utente.isUtenteResponsabileCommessa) {
          <li>
            <a class="nav-link" [ngClass]="{'active': isResponsabileCommessa, 'link-dark': !isResponsabileCommessa}"
              [attr.aria-current]="isResponsabileCommessa ? 'page' : null"
              (click)="navigate('responsabile-commessa/homepage')" onclick="return false" href="/">
              <i class="bi bi-briefcase me-1"></i>
              Responsabile Commessa
            </a>
          </li>
          }
          @if (utente.isUtenteAdmin || utente.isUtentePianificazioneControllo) {
          <li>
            <a class="nav-link"
              [ngClass]="{'active': isPianificazioneControllo, 'link-dark': !isPianificazioneControllo}"
              [attr.aria-current]="isPianificazioneControllo ? 'page' : null"
              (click)="navigate('pianificazione-controllo/homepage')" onclick="return false" href="/">
              <i class="bi bi-calendar-check me-1"></i>
              Pianificazione e Controllo
            </a>
          </li>
          }
          @if (utente.isUtenteAdmin || utente.isUtenteControllerBU) {
          <li>
            <a class="nav-link" [ngClass]="{'active': isControllerBU, 'link-dark': !isControllerBU}"
              [attr.aria-current]="isControllerBU ? 'page' : null" (click)="navigate('controller-bu/homepage')"
              onclick="return false" href="/">
              <i class="bi bi-person-gear me-1"></i>
              Controller BU
            </a>
          </li>
          }
          @if (utente.isUtenteAdmin || utente.isUtenteControllerCentrale) {
          <li>
            <a class="nav-link" [ngClass]="{'active': isControllerCentrale, 'link-dark': !isControllerCentrale}"
              [attr.aria-current]="isControllerCentrale ? 'page' : null"
              (click)="navigate('controller-centrale/homepage')" onclick="return false" href="/">
              <i class="bi bi-person-gear me-1"></i>
              Controller Centrale
            </a>
          </li>
          }
          @if (utente.isUtenteAdmin || utente.isUtenteCFO) {
          <li>
            <a class="nav-link" [ngClass]="{'active': isCFO, 'link-dark': !isCFO}"
              [attr.aria-current]="isCFO ? 'page' : null" (click)="navigate('cfo/homepage')" onclick="return false"
              href="/">
              <i class="bi bi-graph-up-arrow me-1"></i>
              Chief Financial Officer
            </a>
          </li>
          }
          @if (utente.isUtenteAdmin || utente.isUtenteCOO) {
          <li>
            <a class="nav-link" [ngClass]="{'active': isCOO, 'link-dark': !isCOO}"
              [attr.aria-current]="isCOO ? 'page' : null" (click)="navigate('coo/homepage')" onclick="return false"
              href="/">
              <i class="bi bi-people me-1"></i>
              Chief Operating Officer
            </a>
          </li>
          }
          @if (utente.isUtenteAdmin || utente.isUtenteDG) {
            <li>
              <a class="nav-link" [ngClass]="{'active': isDirettoreGenerale, 'link-dark': !isDirettoreGenerale}"
                [attr.aria-current]="isDirettoreGenerale ? 'page' : null" (click)="navigate('direttore-generale/homepage')" onclick="return false"
                href="/">
                <i class="bi bi-people me-1"></i>
                Direttore Generale
              </a>
            </li>
          }
        </ul>
      </div>
    </mat-sidenav>
    <mat-sidenav-content class="example-content">
      <div class="w-100 d-flex align-items-center justify-content-start fixed-top custom-header">
        <!-- @if (utente.hasMultipleRoles) { -->
        <!-- <div class="mt-2">
          <button type="button" class="btn btn-primary ms-2" title="Menu" (click)="sidenavMenu.toggle()">
            <i class="bi bi-list fs-4"></i>
          </button>
        </div> -->
        <!-- } -->
        <div class="w-100">
          <app-header [user]="user"></app-header>
        </div>
      </div>
      <div class="container">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</main>
